import { render, staticRenderFns } from "./SupportTicketThread.vue?vue&type=template&id=6ac83deb&scoped=true&"
import script from "./SupportTicketThread.vue?vue&type=script&lang=js&"
export * from "./SupportTicketThread.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketThread.vue?vue&type=style&index=0&id=6ac83deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac83deb",
  null
  
)

export default component.exports